var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySegmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.5V15.5M16.5 18.5H22.5M12.5 15.5H8.5C6.63623 15.5 5.70435 15.5 4.96927 15.8045C3.98915 16.2105 3.21046 16.9892 2.80448 17.9693C2.5 18.7044 2.5 19.6362 2.5 21.5M16 3.79076C17.4659 4.38415 18.5 5.82131 18.5 7.5C18.5 9.17869 17.4659 10.6159 16 11.2092M14 7.5C14 9.70914 12.2091 11.5 10 11.5C7.79086 11.5 6 9.70914 6 7.5C6 5.29086 7.79086 3.5 10 3.5C12.2091 3.5 14 5.29086 14 7.5Z",
    stroke: "#5C4BAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySegmentIcon);
export default __webpack_public_path__ + "static/media/emptySegmentIcon.58f342d46ca3ff8971059968ee19f8d8.svg";
export { ForwardRef as ReactComponent };